import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    select: {
        height: theme.spacing(10.25),
        maxWidth: theme.spacing(35),
        marginBottom: 0,
        backgroundColor: theme.palette.primary.main,
        boxShadow: "none",
        fontSize: 14,
        "& .MuiTypography-subtitle1": {
            fontSize: "14px !important",
            fontFamily: "Source Sans 3",
        },
        borderRadius: 4,
        width: "initial",
        "& > .MuiSelect-select": {
            fontFamily: "Source Sans 3",
            fontSize: 14,
            color: theme.palette.primary.darker,
        },
    },
    searchBar: {
        width: `100% !important`,
    },
    fullWidth: {
        width: "100%",
        maxWidth: "100%",
    },
}));
